export default __webpack_public_path__ + "static/RecklessNeue-Book-c7887403d006c99decf81e40f745eca2.woff";